module.exports = __webpack_public_path__ + "71c56745afa06c1073a4f3158520b78d.png";